import { MdStore } from 'react-icons/md';
import { RiVipCrown2Fill, RiVipDiamondFill } from 'react-icons/ri';

import { ListingState } from '@/modules/core/types';

import Text from '../Text';

interface CardTagListProps {
  isShop: boolean;
  isNew?: boolean;
  isGold?: boolean;
  isFeatured?: boolean;
  listingState?: ListingState;
  tags?: {}[];
  meiliSynced?: boolean;
}

const StateBadge = ({ color, label }: { color: string; label: string }) => (
  <div className={`  p-2 text-white  text-center ${color || 'bg-blue-500'}`}>
    {label}
  </div>
);

const CardTagList = ({
  isShop = false,
  // isNew = false,
  isGold = false,
  isFeatured = false,
  meiliSynced,
  listingState,
}: CardTagListProps) => {
  const getStateBadge = (state: ListingState) => {
    switch (state) {
      case ListingState.DELETED:
        return (
          <StateBadge
            color="bg-gradient-to-r from-red-500/60 via-red-500 to-red-500/60"
            label="Supprimée"
          />
        );
      case ListingState.SOLD:
        return (
          <StateBadge
            color=" bg-gradient-to-r from-emerald-500/60 via-emerald-500 to-emerald-500/60"
            label="Vendu"
          />
        );
      case ListingState.EXPIRED:
        return (
          <StateBadge
            color="bg-gradient-to-r from-gray-500/60 via-gray-500 to-gray-500/60"
            label="Expirée"
          />
        );
      case ListingState.PENDING_MOD ||
        ListingState.PENDING_MANUAL_MOD ||
        ListingState.PENDING_INSERTION:
        return (
          <StateBadge
            color="bg-gradient-to-r from-blue-500/60 via-blue-500 to-blue-500/60"
            label="En modération"
          />
        );
      case ListingState.REJECTED:
        return (
          <StateBadge
            color="bg-gradient-to-r from-black-500/60 via-black-500 to-black-500/60"
            label="Rejetée"
          />
        );
      case ListingState.ACTIVE:
        return (
          <StateBadge
            color="bg-gradient-to-r from-blue-500/60 via-blue-500 to-blue-500/60"
            label="Active"
          />
        );

      default:
        return (
          <StateBadge
            color="bg-gradient-to-r from-blue-500/60 via-blue-500 to-blue-500/60"
            label="Active"
          />
        );
    }
  };

  return (
    <div className="  absolute top-[35%]  z-40 w-full  pointer-events-none ">
      <div className="flex space-x-1">
        {isShop && (
          <span className="badge bg-blue-500 text-white">
            <MdStore size={12} />
          </span>
        )}
        {/* {isNew ? (
        <span className="badge bg-blue-600/70 text-white">Neuf</span>
      ) : (
        <span className="badge bg-gray-800/50 text-white">Occasion</span>
      )} */}
      </div>
      <div>
        {isGold && (
          <span className="badge bg-black/60 space-x-1">
            <span>
              <svg width="0" height="0">
                <linearGradient
                  id="premium-gradient"
                  x1="100%"
                  y1="100%"
                  x2="0%"
                  y2="0%"
                >
                  <stop stopColor="#fde047" offset="0%" />
                  <stop stopColor="#eab308" offset="100%" />
                </linearGradient>
              </svg>
              <RiVipCrown2Fill
                style={{ fill: 'url(#premium-gradient)' }}
                size={10}
              />
            </span>
            <Text
              text="Gold"
              className="text-3xs bg-gradient-to-r from-yellow-300 to-yellow-500 bg-clip-text text-transparent"
            />
          </span>
        )}
        {isFeatured && !isGold && (
          <span className="badge space-x-1">
            <span>
              <svg width="0" height="0">
                <linearGradient
                  id="featured-gradient"
                  x1="100%"
                  y1="100%"
                  x2="0%"
                  y2="0%"
                >
                  <stop stopColor="#63b3ed" offset="0%" />
                  <stop stopColor="#c026d3" offset="100%" />
                </linearGradient>
              </svg>
              <RiVipDiamondFill
                style={{ fill: 'url(#featured-gradient)' }}
                size={10}
                className=""
              />
            </span>
            <Text
              text="A la une"
              className="text-3xs bg-gradient-to-r from-blue-400 to-fuchsia-600 bg-clip-text text-transparent"
            />
          </span>
        )}
        {listingState !== ListingState.ACTIVE || !meiliSynced ? (
          getStateBadge(listingState || 2)
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default CardTagList;
